import { WorkInterventionDaysRepository } from "@/api/Repositories";
import { TimeWorkedPerDamagePerDayRepository } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    list (state, data) {
      state.list = []
      state.list = data
    },
  },
  actions: {
    list ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        WorkInterventionDaysRepository.get(obj)
          .then(response => {
            const data = response.data.data.time_worked_per_damage_per_days
            for (let i = 0; i < data.length; i++) {
              const element = data[i]
              const damage = element.blade_damage
              const name = [
                damage.wind_turbine,
                damage.location,
                damage.blade_damage_type.name,
                damage.severity,
              ]
              element.name = name.join(' | ')
              element.option = element.blade_damage_id
              element.quantity = element.time_worked
            }
            console.log("list -> data", data)
            commit('list', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    create (context, data) {
      return new Promise((resolve, reject) => {
        TimeWorkedPerDamagePerDayRepository.create(data)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    edit (context, data) {      
      return new Promise((resolve, reject) => {
        TimeWorkedPerDamagePerDayRepository.update(data)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    delete (context, id) {
      return new Promise((resolve, reject) => {
        TimeWorkedPerDamagePerDayRepository.delete(id)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    }
  }
}
